import React, { useState } from 'react';
import proptypes from 'prop-types';
import { Box, Drawer, Stack } from '@metarouter-private/mr-mui';

import TestPlaybookDrawerContextProvider from './TestPlaybookDrawerContextProvider';
import DRAWER_MODES from './TestPlaybookDrawerContextProvider/DRAWER_MODES';
import DrawerHeader from './components/DrawerHeader';
import PipelineVariablesNote from './components/PipelineVariablesNote';
import DrawerTabsSection from './DrawerTabsSection';

export const TransformDrawer = ({ isOpen, onClose, integration, playbookState }) => {
  // Mode lives above the Drawer (whose children unmount on close) so reopening
  // keeps the last-used mode; leaving the editor page resets it to Basic.
  const [mode, setMode] = useState(DRAWER_MODES.BASIC);

  return (
    <Drawer anchor="right" width="70%" open={isOpen} onClose={onClose} data-test-id="test-transform-drawer">
      <Box p={2}>
        <TestPlaybookDrawerContextProvider
          integration={integration}
          playbookState={playbookState}
          mode={mode}
          setMode={setMode}
        >
          <Stack spacing={1}>
            <DrawerHeader onCloseDrawer={onClose} />
            <PipelineVariablesNote />
            <DrawerTabsSection />
          </Stack>
        </TestPlaybookDrawerContextProvider>
      </Box>
    </Drawer>
  );
};
TransformDrawer.propTypes = {
  isOpen: proptypes.bool.isRequired,
  onClose: proptypes.func.isRequired,
  integration: proptypes.object.isRequired,
  playbookState: proptypes.object.isRequired,
};
